import { render } from "./AssistantAi.vue?vue&type=template&id=2c10938c"
import script from "./AssistantAi.vue?vue&type=script&lang=js"
export * from "./AssistantAi.vue?vue&type=script&lang=js"

import "./AssistantAi.vue?vue&type=style&index=0&id=2c10938c&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/AssistantAi/AssistantAi.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2c10938c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2c10938c', __exports__)) {
    api.reload('2c10938c', __exports__)
  }
  
  module.hot.accept("./AssistantAi.vue?vue&type=template&id=2c10938c", () => {
    api.rerender('2c10938c', render)
  })

}


export default __exports__